import * as React from 'react';
import { useDispatch } from 'react-redux';
import {
  fetchApi,
  makeResetCache,
  notifyError,
  notifyResponse,
  RecordPicker,
  useCacheRecord,
} from 'gossamer-front-end';
import { AdminOrgUnitMemberAddRequest, OrgUnitMember, OrgUnitMemberView, UserView } from 'cb-model';
import { InputGroup } from 'react-bootstrap';
import { FieldType } from 'gossamer-unified';

export interface AddMemberToOrgUnitButtonProps {
  orgUnitId: number;
}

export const AddMemberToOrgUnitButton: React.FC<AddMemberToOrgUnitButtonProps> = (props): React.JSX.Element => {
  const [userId, setUserId] = React.useState<string | null>(null);
  return (
    <InputGroup>
      <InputGroup.Text>Add an existing Member to this Org Unit</InputGroup.Text>
      <RecordPicker
        editable={true}
        onItemSelected={setUserId}
        value={userId}
        field={{
          seq: 0,
          type: FieldType.Reference,
          label: 'Member',
          refEntity: UserView,
        }}
      />
      {userId && <Execute {...props} setUserId={setUserId} userId={userId} />}
    </InputGroup>
  );
};

interface ExecuteProps {
  orgUnitId: number;
  setUserId: (newUserId: string) => void;
  userId: string;
}

const Execute = (props: ExecuteProps): React.JSX.Element => {
  const userRecord = useCacheRecord(UserView, props.userId);
  const isProcessing = React.useRef(false);
  const dispatch = useDispatch();
  const resetCache = makeResetCache(dispatch);
  const exec = async () => {
    if (isProcessing.current) {
      return;
    }
    try {
      isProcessing.current = true;
      const response = await fetchApi('POST', `/main/org-unit-member-add`, {
        invites: [{ emailAddress: userRecord.data?.email, addToOrgUnitIds: [props.orgUnitId], toBeAdmin: false }],
      } as AdminOrgUnitMemberAddRequest);
      resetCache(UserView.id, props.userId); // why?
      resetCache(OrgUnitMember.id);
      resetCache(OrgUnitMemberView.id);
      props.setUserId(null);
      notifyResponse(response);
    } catch (e) {
      notifyError(e, 'An error occurred while adding the member to the org unit');
    }
    isProcessing.current = false;
  };
  React.useEffect(() => {
    if (userRecord.data) {
      exec();
    }
  }, [userRecord.data]);
  return null;
};
